import { Link } from 'react-router-dom'

/** One masthead tab: Button-style label; selected = accent label and a 3 px accent rule under it. */
// data-count: the Saved count once it is known (journey tests wait for it instead of reading "Saved" as 0)
export function MastTab({ to, label, on, count, className = '' }: { to: string; label: string; on: boolean; count?: number | null; className?: string }) {
  return (
    <Link to={to} aria-current={on ? 'page' : undefined} data-count={count ?? undefined}
      className={`press relative inline-flex min-h-11 items-center whitespace-nowrap text-[16px] font-semibold leading-6 ${className} ${on ? 'text-accent' : 'text-ink-2 hover:text-ink'}`}>
      {label}
      {on && <span aria-hidden="true" className="absolute inset-x-0 bottom-0 h-[3px] bg-accent" />}
    </Link>
  )
}
